import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import GenerateDialog from "../components/GenerateDialog";
import { useI18n } from "../lib/i18n";
import api from "../lib/api";
import { Wand2 } from "lucide-react";

export default function Studio() {
  const { t } = useI18n();
  const [params, setParams] = useSearchParams();
  const genId = params.get("gen");
  const [seed, setSeed] = useState(null);
  const [ready, setReady] = useState(!genId);

  // Opened from the Prompt Library: load that generation (prompt, model, settings, media as reference/start frame).
  useEffect(() => {
    if (!genId) return;
    api.get(`/generation/${genId}`).then(({ data: g }) => {
      const isVid = g.type === "video";
      setSeed({
        key: `gen:${g.generation_id}`, prompt: g.prompt_text || "", vid: isVid, promptId: g.prompt_id || null,
        modelId: g.model, size: g.size || "", resolution: g.resolution || "", duration: g.duration || "", aspect: g.aspect || "",
        refs: !isVid ? (g.original_refs || []) : [], refMode: g.original_ref_mode || "edit",
        start: isVid && g.start_frame ? { kind: "gallery", id: g.start_frame } : null,
      });
    }).catch(() => {}).finally(() => { setReady(true); params.delete("gen"); setParams(params, { replace: true }); });
    // eslint-disable-next-line
  }, [genId]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-8" data-testid="studio-page">
      <h1 className="text-3xl sm:text-4xl font-bold flex items-center gap-3 mb-2">
        <Wand2 className="w-7 h-7 text-orange-400" /> {t("nav_studio")}
      </h1>
      <p className="text-sm text-zinc-400 mb-6">{t("studio_sub")}</p>
      <div className="rounded-2xl border border-white/10 bg-[#0d0d0d] p-4 sm:p-6">
        {ready && <GenerateDialog inline open editablePrompt onOpenChange={() => {}} promptText="" seed={seed} />}
      </div>
    </div>
  );
}
